export default __webpack_public_path__ + "static/210521_妲絲刷關活動熱更預告_kr-18f16551c734133770f6aa5a047f3b3d.png";